export default {
  ACTIVE: 'active',
  PAUSED: 'paused',
  SUSPEND: 'suspend',
}
